<div>
    @for (toast of toastService.toasts; track toast) {
        <ngb-toast
                [class]=" toast.type === 'SUCCESS' ? 'bg-success text-light' : 'bg-danger text-light'"
                [autohide]="true"
                [delay]="3000"
                (hidden)="toastService.remove(toast)">
            <div>
                <div><strong>{{ toast.type === 'SUCCESS' ? "Success!" : "Whoops!" }}</strong></div>
                <div>{{ toast.message }}</div>
            </div>
        </ngb-toast>
    }
</div>
